// extracted by mini-css-extract-plugin
export default {"icon":"icon-IxdN0N4y"};